export default "__VITE_ASSET__1d472724__"